import { useNextButton } from 'components/Carousel/useNextButton'
import { ScrollButtonProps } from 'screens/blaze/Home/components/Catalogue/components/ScrollButton/Types'
import cx from 'classnames'
import Styles from './ScrollButton.module.scss'
import { ChevronRight } from 'blaze-ui/icons/24'

export const NextButton = (props: ScrollButtonProps) => {
  const { isFocusVisible, isDisabled, isPressed, buttonProps, buttonRef } = useNextButton(props)

  return (
    <button
      ref={buttonRef}
      className={cx(Styles.scrollButton, {
        [Styles.disabled]: isDisabled,
        [Styles.pressed]: isPressed,
        [Styles.focused]: isFocusVisible,
      })}
      disabled={isDisabled}
      aria-label="Next"
      {...buttonProps}
    >
      <ChevronRight size={24} />
    </button>
  )
}
